import React from 'react';

const InvestmentSectionTabs = ({ tabs, activeTab, onChange, className = '' }) => (
    <div className={`flex flex-wrap gap-2 ${className}`.trim()}>
        {tabs.map((tab) => {
            const isActive = tab.id === activeTab;
            return (
                <button
                    key={tab.id}
                    type="button"
                    onClick={() => onChange(tab.id)}
                    className={`px-3 py-2 rounded-lg text-sm font-medium transition ${
                        isActive
                            ? 'bg-blue-600 text-white shadow-sm'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                >
                    {tab.label}
                </button>
            );
        })}
    </div>
);

export default InvestmentSectionTabs;
